$(function(){
    $("#category #open-filters, #module-pm_advancedsearch4-searchresults  #open-filters, .advancedsearch-seo  #open-filters, .page-module-pm-advancedsearch4-seo  #open-filters" ).click(function () {
        $("#left-column").toggleClass("open");
        $("body").toggleClass("overflow-hidden");
    });
    $("body").on("click",".PM_ASMobileMode *",function () {
        $("#left-column").removeClass("open");
        $("#left-column").scrollTop(0)
        $("body").removeClass("overflow-hidden");
    })
    $("#open_top_right_menu").click(function(){
        $("#menu_top_right_container").toggleClass("open");
    });
    $("#back_to_top").click(function(){
        $("body,html").animate({scrollTop:0},500);
    });

    $(".product-accessories .owl-carousel").owlCarousel({
        items:4,
        nav:true,
        responsive : {
            // breakpoint from 0 up
            0 : {
                items : 2
            },
            // breakpoint from 480 up
            768 : {
                items : 3
            }
        }
    });
    switch ($("body").attr("id")){
        case "naturalsoul":
            $(".menu-natural-soul").addClass("active");
            break;
        case "contact":
            $(".menu-contact").addClass("active");
            break;
        case "trattamenti":
        case "professional":
            var theClass = $("body").attr("class").match(/rewrite[\w-]*\b/)[0].substr(8, 100);
            $(".menu-"+theClass).addClass("active");
            $(".menu-products").addClass("active");
            break;
        case "man":
            $(".menu-linea-man").addClass("active");
            $(".menu-products").addClass("active");
            break;
        case "product":
            var theClass = $("body").attr("class").match(/product-id-[\w-]*\b/)[0].substr(11, 100);
            switch(theClass) {
                case "243":
                    $(".advtm_column_wrap_td_3 .menu-shampoo").addClass("active");
                    break;
                case "244":
                    $(".advtm_column_wrap_td_3 .menu-leave-in").addClass("active");
                    break;
            }
            $(".menu-products").addClass("active");
            break;
        case "category":
            var theClass = $("body").attr("class").match(/category-id-[\w-]*\b/)[0].substr(12, 100);
            switch(theClass){
                case "3":
                    $(".menu-1").addClass("active");
                    break;
                case "12":
                    $(".menu-2").addClass("active");
                    break;
                case "13":
                    $(".menu-3").addClass("active");
                    break;
                case "15":
                    $(".menu-4").addClass("active");
                    break;
                case "16":
                    $(".menu-5").addClass("active");
                    break;
                case "17":
                    $(".menu-6").addClass("active");
                    break;
                case "18":
                    $(".menu-7").addClass("active");
                    break;
                case "19":
                    $(".menu-8").addClass("active");
                    break;
                case "96":
                    $(".menu-35").addClass("active");
                    break;
                case "97":
                    $(".menu-36").addClass("active");
                    break;
                case "98":
                    $(".menu-37").addClass("active");
                    break;
                case "99":
                    $(".menu-38").addClass("active");
                    break;
            }
            $(".menu-products").addClass("active");
            break;
    }
});

$(window).resize(function(){
    if(typeof map !== "undefined") {
        map.panTo(uluru)
    }
});


// WEBPACK FOOTER //
// ./js/gabri.js